import { ComplianceSubmitUserRequestType } from 'src/api_openapi/v2/gamprotect/schemas';
import { StaffAccountBasicDataType } from 'src/AppState/sdk/staff';
import { MarkerType } from './types';
import moment from 'moment';

export interface GamprotectRequestSuccessDataType {
    success: true;
    data: Omit<ComplianceSubmitUserRequestType, 'entryReason'>;
}

export interface GamprotectRequestErrorDataType {
    success: false;
    message: string;
}

export const convertCustomerDataForGamprotect = (
    data: StaffAccountBasicDataType | null
): GamprotectRequestSuccessDataType | GamprotectRequestErrorDataType => {
    if (data === null) {
        return {
            success: false,
            message: 'Unknown customer data',
        };
    }

    const { id, firstName, surname, birthDate, email, postCode, mobilePhone, universe } = data;

    if (firstName === null || firstName === undefined) {
        return {
            success: false,
            message: 'Unknown firstName',
        };
    }

    if (surname === null || surname === undefined) {
        return {
            success: false,
            message: 'Unknown surname',
        };
    }

    if (email === null || email === undefined) {
        return {
            success: false,
            message: 'Unknown email',
        };
    }

    if (postCode === null || postCode === undefined) {
        return {
            success: false,
            message: 'Unknown postCode',
        };
    }

    if (mobilePhone === null || mobilePhone === undefined) {
        return {
            success: false,
            message: 'Unknown mobilePhone',
        };
    }

    return {
        success: true,
        data: {
            universe,
            accountId: id,
            firstName: firstName,
            lastName: surname,
            dateOfBirth: birthDate,
            emailAddress: email,
            postcode: postCode,
            mobile: mobilePhone.number,
        },
    };
};

export const sortMarkersByStatus = (markers: Array<MarkerType>): Array<MarkerType> => {
    return markers.sort((a, b) => {
        if (a.active && !b.active) {
            return -1;
        }

        if (!a.active && b.active) {
            return 1;
        }
        return moment(a.firstSeen).isSameOrAfter(b.firstSeen) ? 1 : -1;
    });
};
